<template>
    	<!-- <el-form :model="vo" @submit.native.prevent>
	    <div style="width:100%;" class="el-table el-table--fit el-table--border">
	      <div class="el-table__body-wrapper">
	        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body ">
	          <tbody>
	          	<tr >
	          		<td ref="tdlbl_员工姓名" class="el-table__cell tdlbl tdw13" colspan="1">

	                    <span class="field" v-field-lbl="'teacherName'">员工姓名</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw20" colspan="1">
	          				<form-item ref="teacherName" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'员工姓名','propName':'teacherName','propType':'String','textFormatter':'textfield','valueMaxLength':100,'valueMinLength':null,'tbFieldName':'teachername','iconName':'puwb','model':'vo.teacherName','option':[],'formTdAlign':'text-left','dialog':1,'dialogType':'staff','dialogOrgLevel':'','dialogSelectedOrderBy':'orgOrderNo','dialogMultiple':false,'dialogOrgSelf':false,'dialogOnlyCurSys':true,'dialogShowmobile':true,'dialogShowemail':false,'dialogShowaccount':false,'dialogTitle':'请选择'}" :vo="vo" :can-edit="canEdit"  />
	                </td>
                    <td ref="tdlbl_合同名称" class="el-table__cell tdlbl tdw13" colspan="1">

                        <span class="field" v-field-lbl="'contractName'">合同名称</span>
                    </td>
                    <td class="el-table__cell tdcont tdw20" colspan="1">
                    		<form-item ref="contractName" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入合同名称','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'合同名称','propName':'contractName','propType':'String','textFormatter':'textfield','valueMaxLength':100,'valueMinLength':null,'model':'vo.contractName','option':[]}" :vo="vo" :can-edit="canEdit"  />
                    </td>
                    <td ref="tdlbl_合同编号" class="el-table__cell tdlbl tdw13" colspan="1">

                        <span class="field" v-field-lbl="'contractNumber'">合同编号</span>
                    </td>
                    <td class="el-table__cell tdcont tdw20" colspan="1">
                    		<form-item ref="contractNumber" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'input','emptyMessage':'请输入合同编号','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'合同编号','propName':'contractNumber','propType':'String','textFormatter':'textfield','valueMaxLength':50,'valueMinLength':null,'model':'vo.contractNumber','option':[]}" :vo="vo" :can-edit="canEdit"  />
                    </td>
	          	</tr>
	          	<tr >
	          		<td ref="tdlbl_合同开始日期" class="el-table__cell tdlbl tdw13" colspan="1">

	                    <span class="field" v-field-lbl="'startDate'">合同开始日期</span>
	                </td>
	          		<td class="el-table__cell tdcont tdw20" colspan="1">
                        <form-item ref="startDate" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'日期选择框','propName':'startDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'startDate','iconName':'rqxzk','model':'vo.startDate','option':[],'formTdAlign':'text-left','weekday':0,'formTdColspan':24}" :vo="vo" :can-edit="canEdit"  />
	                </td>
                    <td ref="tdlbl_合同结束日期" class="el-table__cell tdlbl tdw13" colspan="1">

                        <span class="field" v-field-lbl="'endDate'">合同结束日期</span>
                    </td>
                    <td class="el-table__cell tdcont tdw20" colspan="1">
                        <form-item ref="endDate" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'','elementReadonly':1,'elementType':'date','emptyMessage':'','errorMessage':null,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'日期选择框','propName':'endDate','propType':'java.util.Date','textFormatter':'yyyy-MM-dd','valueMaxLength':null,'valueMinLength':null,'tbFieldName':'endDate','iconName':'rqxzk','model':'vo.endDate','option':[],'formTdAlign':'text-left','weekday':0,'formTdColspan':24}" :vo="vo" :can-edit="canEdit"  />
                    </td>
                    <td ref="tdlbl_备注" class="el-table__cell tdlbl tdw13" colspan="1">

                        <span class="field" v-field-lbl="'remarks'">备注</span>
                    </td>
                    <td class="el-table__cell tdcont tdw20" colspan="1">
                    		<form-item ref="remarks" :field="{'defaultValue':null,'elementCanEdit':'{${canEdit}}','elementCssHeight':70,'elementCssWidth':null,'elementFormatter':null,'elementReadonly':0,'elementType':'textarea','emptyMessage':'请输入备注','errorMessage':null,'formTdAlign':'text-left','formTdColspan':0,'isRequired':0,'onClickEvent':null,'passenger':{},'propComment':'备注','propName':'remarks','propType':'String','textFormatter':'textarea','valueMaxLength':null,'valueMinLength':null,'model':'vo.remarks','option':[]}" :vo="vo" :can-edit="canEdit"  />
                    </td>
	          	</tr>
		          <tr >
		          	<td ref="tdlbl_附件" class="el-table__cell tdlbl tdw17">

			  			<span class="field" v-field-lbl="''">附件</span>
	                </td>
	                <td class="el-table__cell tdcont tdcont" colspan="5">
	                  <Attachment ref="attachments" :vo="vo" :is-required="0" accept="*.*"  empty-message="" wf-attach-url="" :limit-count="10" online-editor="" online-file="" :attachments="vo.passenger.attachments"
			  			:attachs-type="'ATTACH'" :is-drag="0" :auto-upload="0"/>
	                </td>
	              </tr>
	          	<tr >

	          	</tr>
	          </tbody>
	        </table>
          </div>
	    </div>
	 </el-form> -->
     <inner-table id="innerTableContract" ref="contractList" :listviewurl="'teacher.contractInfo.list'" :can-edit="0" :can-delete="1" :link-prop-name="'orgCode'" />
</template>

<script>
export default {
 	props: {
 	    vo: { type: Object, default: function() { return {} } },
        canEdit: { type: Number, default: 1 },
        moduleInfo: { type: Object, default: function() { return {} } }
    },
    data: function() {
        return {
        	loginUser: this.$store.getters.loginUser
        }
    },
    computed: {
    },
    watch: {
    },
    created: function() {
        if (this.$parent.$vnode.context.activeTabIndex) {
            this.activeTabName = this.$parent.$vnode.context.activeTabIndex
        }

	    this.$set(this.$vnode.context, 'wfAttach', false)
    },
    beforeDestroy: function() {
    },
    mounted: function() {
    },
    methods: {

    }
}
</script>

<style scoped>
</style>
